export default {
  namespaced: true,

  state: () => ({
    firstProductRegistry: {},
    paidProductRegistry: {},
    productRegistryPrice: {
      average: 0,
    },
    productRegistryCategory: {},
    sharedGiftPercentage: {},
    reportMounthly: '',
    monthsOptions: [
      { label: 'Januari', value: 1 },
      { label: 'Februari', value: 2 },
      { label: 'Maret', value: 3 },
      { label: 'April', value: 4 },
      { label: 'Mei', value: 5 },
      { label: 'Juni', value: 6 },
      { label: 'Juli', value: 7 },
      { label: 'Agustus', value: 8 },
      { label: 'September', value: 9 },
      { label: 'Oktober', value: 10 },
      { label: 'November', value: 11 },
      { label: 'Desember', value: 12 },
    ],
  }),

  mutations: {
    SET_FIRST_PRODUCT_REGISTRY(state, payload) {
      state.firstProductRegistry = payload
    },
    SET_PAID_PRODUCT_REGISTRY(state, payload) {
      state.paidProductRegistry = payload
    },
    SET_PRODUCT_REGISTRY_PRICE(state, payload) {
      state.productRegistryPrice = payload
    },
    SET_PRODUCT_REGISTRY_CATEGORY(state, payload) {
      state.productRegistryCategory = payload
    },
    SET_SHARED_GIFT_PERCENTAGE(state, payload) {
      state.sharedGiftPercentage = payload
    },
    SET_REPORT_MONTHLY(state, payload) {
      state.reportMounthly = payload
    },
  },

  actions: {
    async getFirstProductRegistry({ commit }, {
      interval = 'month',
      startDate = null,
      endDate = null,
    } = {}) {
      try {
        const today = new Date()
        const nextweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7)
        const nextMonth = new Date(today.getFullYear(), today.getMonth() - 1, today.getDate())
        const nextYear = new Date(today.getFullYear() - 1, today.getMonth(), today.getDate())

        let endDateFilter = ''

        if (startDate && endDate) {
          endDateFilter = startDate
        } else {
          switch (interval) {
            case 'month':
              endDateFilter = nextMonth
              break
            case 'year':
              endDateFilter = nextYear
              break
            default:
              endDateFilter = nextweek
          }
        }

        let frequency = ''
        const startD = new Date(endDateFilter)
        const endD = (startDate && endDate) ? new Date(endDate) : today
        const diffTime = Math.abs(endD - startD)
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24))

        if (diffDays > 90) {
          frequency = 'monthly'
        }

        const url = '/v1/backoffice/diagram/first-product-registry'

        const response = await this._vm.$http.get(url, {
          params: {
            'filter[start_date]': endDateFilter,
            'filter[end_date]': (startDate && endDate) ? endDate : today,
            'filter[frequency]': frequency,
          },
        })

        commit('SET_FIRST_PRODUCT_REGISTRY', response.data.data)

        return response.data.data
      } catch (error) {
        return error
      }
    },
    async getProductPaidRegistry({ commit }) {
      try {
        const url = '/v1/backoffice/diagram/paid-product-registry'

        const response = await this._vm.$http.get(url)

        commit('SET_PAID_PRODUCT_REGISTRY', response.data.data)

        return response.data.data
      } catch (error) {
        return error
      }
    },
    async getProductRegistryPrice({ commit }) {
      try {
        const url = '/v1/backoffice/diagram/product-registry-price'

        const response = await this._vm.$http.get(url)

        commit('SET_PRODUCT_REGISTRY_PRICE', response.data.data)

        return response.data.data
      } catch (error) {
        return error
      }
    },
    async getProductRegistryCategory({ commit }) {
      try {
        const url = '/v1/backoffice/diagram/product-registry-category'

        const response = await this._vm.$http.get(url)

        commit('SET_PRODUCT_REGISTRY_CATEGORY', response.data.data)

        return response.data.data
      } catch (error) {
        return error
      }
    },
    async getSharedGiftPercentage({ commit }) {
      try {
        const url = '/v1/backoffice/diagram/shared-gift-percentage'

        const response = await this._vm.$http.get(url)

        commit('SET_SHARED_GIFT_PERCENTAGE', response.data.data)

        return response.data.data
      } catch (error) {
        return error
      }
    },
    async getReportMounthly({ commit }, {
      startMonth = null, endMonth = null, startYear = null, endYear = null,
    }) {
      try {
        const startReport = `filter[start_report]=${startYear}-${startMonth}`
        const endReport = `filter[end_report]=${endYear}-${endMonth}`
        const sort = 'sort=date'

        const url = `/v1/backoffice/diagram/report-registry-monthly?${startReport}&${endReport}&${sort}`

        const response = await this._vm.$http.get(url)

        commit('SET_REPORT_MONTHLY', response.data.data.map(item => ({
          ...item,
          all_internal_transaction_count: item.internal_non_registry_transaction_count + item.internal_registry_transaction_count,
        })))

        return response.data.data
      } catch (error) {
        if (error.response.data.statusCode === 400) commit('SET_REPORT_MONTHLY', [])
        return error
      }
    },
  },
}
